import { render, staticRenderFns } from "./MeasuresDropdown.vue?vue&type=template&id=37cd1891&scoped=true&"
import script from "./MeasuresDropdown.vue?vue&type=script&lang=js&"
export * from "./MeasuresDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MeasuresDropdown.vue?vue&type=style&index=0&id=37cd1891&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd1891",
  null
  
)

export default component.exports